var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/view.ts
import { ID } from "@adornis/baseql/baseqlTypes.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import "@adornis/baseql/entities/adornisEntity.js";
import { MongoEntity } from "@adornis/baseql/entities/mongoEntity.js";
import { FieldConfiguration } from "@adornis/field-management/field-configuration.js";
import { AdornisFilter } from "@adornis/filter/AdornisFilter.js";
var View = class extends MongoEntity {
  toggleSelection(key) {
    this.selectedItems ??= [];
    if (!this.multiSelection) {
      if (this.selectedItems.length && this.selectedItems[0] === key) {
        this.selectedItems = [];
      } else {
        this.selectedItems = [key];
      }
    } else {
      if (this.selectedItems.includes(key)) {
        this.selectedItems.splice(this.selectedItems.indexOf(key), 1);
      } else {
        this.selectedItems.push(key);
      }
    }
  }
  constructor(doc) {
    super(doc);
  }
};
View._class = "View";
View._collectionName = "views";
__decorateClass([
  Field((type) => AdornisFilter)
], View.prototype, "filter", 2);
__decorateClass([
  Field((type) => String)
], View.prototype, "mode", 2);
__decorateClass([
  Field((type) => [FieldConfiguration])
], View.prototype, "configuredColumns", 2);
__decorateClass([
  Field((type) => Boolean, { default: (v) => v ?? false })
], View.prototype, "multiSelection", 2);
__decorateClass([
  Field((type) => [ID], { default: (v) => v ?? [] })
], View.prototype, "selectedItems", 2);
View = __decorateClass([
  Entity()
], View);
export {
  View
};
